<template>
  <v-bottom-sheet inset persistent no-click-animation v-model="value" width="100%" hide-overlay content-class="stripe-conditions-sheet">
    <v-card>
      <v-card-text class="card-text">
        <div class="d-flex align-center">
          <div class="content-body flex-grow-1">
            <h3>
              Stripe Terms and Conditions
            </h3>
            <p class="copy">
              {{ dialogText }}
              <a href="https://stripe.com/connect-account/legal" class="link" target="_blank" style="padding-left: 4px; padding-right: 1rem;">
                {{ $t('components.stripeTermsConditions.link') }}
              </a>
            </p>
          </div>
          <v-btn
            color="blue"
            class="white--text"
            @click="onAgreeClick"
          >{{ $t('misc.agree') }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'StripeConditionsSnackbar',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    onAgreeCallback: {
      type: Function,
      required: false,
    },
    bodyCopy: {
      type: String,
      required: false,
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    dismiss() {
      this.value = false;
      this.$emit('input', this.value);
    },
    onAgreeClick() {
      this.value = false;
      this.$emit('input', this.value);
      this.$emit('onAgree');

      if (this.onAgreeCallback) {
        this.onAgreeCallback();
      }
    },
  },
  computed: {
    dialogText() {
      if (this.bodyCopy) {
        return this.bodyCopy;
      }
      return this.$t('components.stripeTermsConditions.consoleBannerCopy');
    },
  },
};
</script>

<style scoped lang="scss">
  .v-card__text.card-text {
    background: #000;
    padding: 2rem;
    color: #FFFFFF;

    .link {
      color: #247DFF;
    }
  }
</style>
